import { TTransceiver } from 'src/features/new-delivery-request/types.ts';
import { atom, useAtom, useSetAtom } from 'jotai';

export const senderAtom = atom<TTransceiver | undefined>(undefined);
export const useNewDeliveryRequestSenderAtom = () => {
  return useAtom(senderAtom);
};
export const useNewDeliveryRequestSenderSetAtom = () => {
  return useSetAtom(senderAtom);
};
